import { render, staticRenderFns } from "./DriveLogoSvg.vue?vue&type=template&id=06f80f84&"
import script from "./DriveLogoSvg.vue?vue&type=script&lang=js&"
export * from "./DriveLogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports